import { Button, Checkbox, Form, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useState } from "react";
import { useMemo } from "react";
import NotSet from "../../../components/NotSet";
import { ListingProperties } from "../../../types/listing.type";
import ListingModal from "../Components/ListingModal";
import { TransferListingItem } from "../Create";
import { ListingViewProps } from "../CreateComponents/interface";
import { capitalizeFirstLetter } from "../../../helpers/text";
import { doFilterItem } from "../helper";

const ListingListView: React.FC<ListingViewProps> = ({
	disablePickSingle,
	fieldName,
	onShowSingleTransfer,
	checkAllState,
	onCheckAll,
	filtered,
}) => {
	const [showDetail, setShowDetail] = useState<ListingProperties | undefined>();

	const arrayfieldName = useMemo(() => {
		if (fieldName instanceof Array) {
			return fieldName;
		}
		return [fieldName];
	}, [fieldName]);

	const COLUMNS: ColumnsType<TransferListingItem> = [
		{
			title: (
				<Checkbox
					checked={checkAllState?.checked}
					indeterminate={checkAllState?.indeterminate}
					onChange={(e) => onCheckAll?.(e.target.checked)}
				/>
			),
			dataIndex: "checked",
			key: "checked",
			width: 40,
			render: (value: boolean, record: TransferListingItem, index: number) => {
				return (
					<Form.Item
						noStyle={true}
						name={[...arrayfieldName, index, "checked"]}
						valuePropName="checked"
					>
						<Checkbox />
					</Form.Item>
				);
			},
		},
		{
			title: "LISTING ID",
			dataIndex: "listingCode",
			key: "listingCode",
			width: 100,
			render: (value: string | undefined, record: TransferListingItem) => {
				return (
					<Button
						style={{ padding: 0 }}
						type="link"
						onClick={() => setShowDetail(record)}
					>
						{value ?? <NotSet />}
					</Button>
				);
			},
		},
		{
			title: "TITLE",
			dataIndex: "title",
			key: "title",
			width: 200,
		},
		{
			title: "CITY",
			dataIndex: "city",
			key: "city",
			// ellipsis: true,
			width: 150,
		},
		{
			title: "AGENT NAME",
			dataIndex: ["agent", "name"],
			key: "agentName",
			width: 150,
		},
		{
			title: "STATUS",
			dataIndex: "status",
			key: "status",
			width: 100,
			render: (value: string) => capitalizeFirstLetter(value),
		},
		!disablePickSingle
			? {
					title: "",
					dataIndex: "listingId",
					key: "listingId",
					width: 100,
					render: (listingId: string, item: TransferListingItem) => {
						return (
							<Button
								type="link"
								danger={true}
								onClick={() => {
									onShowSingleTransfer?.(item);
								}}
							>
								Move Listing
							</Button>
						);
					},
			  }
			: {},
	].filter(Boolean);

	interface RenderItemProps {
		value?: TransferListingItem[];
		onChange?: (values?: TransferListingItem[]) => void;
	}
	const RenderItem: React.FC<RenderItemProps> = ({ value, onChange }) => {
		const filteredItems = useMemo(() => {
			if (value && (filtered?.search || filtered?.type)) {
				return (value ?? [])?.filter((item) => item && doFilterItem(item, filtered?.search!, filtered?.type!));
			}
			return value;
		}, [value]);
		return (
			<Table
				className="table-grey-header"
				columns={COLUMNS}
				dataSource={filteredItems}
				size="small"
				pagination={false}
				scroll={{
					y: 445,
					x: "100%",
				}}
				rowKey="listingId"
				locale={{
					emptyText: "Listing Empty",
				}}
			/>
		);
	};

	return (
		<React.Fragment>
			<Form.Item
				name={fieldName}
				noStyle={true}
			>
				<RenderItem />
			</Form.Item>
			<ListingModal
				open={showDetail !== undefined}
				onClose={() => setShowDetail(undefined)}
				listing={showDetail}
			/>
		</React.Fragment>
	);
};
export default ListingListView;
